"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStandingCcInput = exports.createStandingCcInput = exports.standingCcListSchema = exports.standingCcSchema = exports.standingCcScopeSchema = void 0;
exports.isEmailAddress = isEmailAddress;
/**
 * `RPM-044` — the tenant's standing copies: an address copied on every alert email (`ALERT`) or every
 * summary (`SUMMARY`), maintained by an administrator (`J-282`).
 *
 * A COPY NEVER DISCHARGES A STEP. The obligation is to the facility's recipients; the routing adds the
 * active copies of a scope to each email step's or summary's copy list (`RPM-070`, `RPM-103`), and a
 * step whose only recipients would be the copies is `UNMET` (`RPM-035`).
 *
 * THE ADDRESS IS CHECKED BY THE SERVICE, NOT THE BODY SCHEMA, because the block's Blocking row makes a
 * malformed address `422`, and a body schema's refusal is `400`.
 */
const zod_1 = require("zod");
const rpm_enums_js_1 = require("./db/rpm-enums.js");
exports.standingCcScopeSchema = zod_1.z.enum(rpm_enums_js_1.standingCcScope.enumValues);
/** One standing copy, as the administration list shows it. */
exports.standingCcSchema = zod_1.z.object({
    standingCcId: zod_1.z.uuid(),
    scope: exports.standingCcScopeSchema,
    address: zod_1.z.string(),
    label: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    updatedAt: zod_1.z.iso.datetime(),
});
/** The tenant's copies, active first, then by scope and address. */
exports.standingCcListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.standingCcSchema),
});
exports.createStandingCcInput = zod_1.z.strictObject({
    scope: exports.standingCcScopeSchema,
    address: zod_1.z.string().trim().min(1).max(320),
    label: zod_1.z.string().trim().min(1).max(120),
});
/** Editing or deactivating one. Deactivation is `isActive: false`; nothing deletes a copy. */
exports.updateStandingCcInput = zod_1.z
    .strictObject({
    address: zod_1.z.string().trim().min(1).max(320).optional(),
    label: zod_1.z.string().trim().min(1).max(120).optional(),
    isActive: zod_1.z.literal(false).optional(),
})
    .refine((v) => Object.keys(v).length > 0, {
    message: "Send at least one field to change.",
});
/** Whether an address is one an email can be sent to: the check behind the block's `422`. */
function isEmailAddress(address) {
    return zod_1.z.email().safeParse(address).success;
}
//# sourceMappingURL=rpm-standing-ccs.js.map